import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Popover,
    Card,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
//   import {
//     updateActivationStatus,
//   } from "./orderapiFunctions";
import { getordersDetails, getallrestroList, restroDisabled } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"


const AllRestroList = () => {

    const [orderData, setorderData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [currentStatus, setCurrentStatus] = useState();

    const handleChangeStatus = (id, status) => {
        setIsLoading(true);
        console.log(status);
        const newStatus = status == 1 ? 0 : 1; // Toggle status

        restroDisabled({

            "isActive": newStatus,
            "restaurantId": id

        })
            .then((response) => {
                if (response.status) {
                    message.success("Status updated successfully");
                    setCurrentStatus(newStatus); // Update local state
                    FetchordersDetails();
                } else {
                    message.error("Failed to update status");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
                setIsLoading(false);
            });
    };

    const popoverContent = (id, status) => (
        <div>
            <p>Are you sure you want to change the status?</p>
            <Button
                type="primary"
                onClick={() => handleChangeStatus(id, status)}
                disabled={isLoading}
            >
                {isLoading ? <Spin size="small" /> : "Confirm"}
            </Button>
        </div>
    );

    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const from = location.state?.from;
    console.log(from);


    const FetchordersDetails = (page) => {
        setIsLoading(true);
        getallrestroList(`?name=${searchTerm}`)
            .then((response) => {
                if (response.status) {
                    setorderData(response.data || []);
                    setCurrentPage(response.data?.pagination.currentPage || 1);
                    setTotalPages(response.data?.pagination.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching order details:", err);
                setIsLoading(false);
            });
    };
    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };

    // function changeActiveStatus(checked, record) {
    //   console.log(checked, record);
    //   const isDeleteAction = checked === undefined;

    //   let payload = {
    //     name: record.name,
    //     is_active: isDeleteAction ? (checked ? "1" : "0") : record.is_active,
    //     is_deleted: isDeleteAction ? "0" : "1",
    //   };

    //   updateActivationStatus(payload, record.id)
    //     .then((response) => {
    //       if (response.data.status === "success") {
    //         const updatedorderTable = orderData.map((item) =>
    //           item.id === record.id
    //             ? {
    //               ...item,
    //               is_active: isDeleteAction
    //                 ? item.is_active
    //                 : payload.is_active,
    //             }
    //             : item
    //         );
    //         setorderData(updatedorderTable);
    //         FetchordersDetails(currentPage);
    //         message.open(
    //           messageConfiguration(
    //             "success",
    //             isDeleteAction
    //               ? "Category deleted successfully."
    //               : response.message,
    //             3
    //           )
    //         );
    //         if (!isDeleteAction) {
    //           FetchordersDetails(currentPage);
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       message.open(
    //         messageConfiguration(
    //           "error",
    //           isDeleteAction
    //             ? "Failed to delete category."
    //             : "Failed to update status.",
    //           3
    //         )
    //       );
    //     });

    // }

    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }
    // console.log("tottaaaaaaaaaaal", totalPage);
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };

    useEffect(() => {
        FetchordersDetails(currentPage);
    }, [currentPage, searchTerm]);


    const columnReports = [
        {
            title: "User Name",
            dataIndex: "username",
            key: "username",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {record.username?.toUpperCase() ?? "--"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.email ?? "--"}</p>
                    </>
                );
            },
        },
        {
            title: "Contact",
            dataIndex: "phone",
            key: "phone",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.phone ?? "--"}</p>
                    </>
                );
            },
        },

        {
            title: "Created Time",
            dataIndex: "register_date",
            key: "register_date",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Action",
            dataIndex: "status",
            key: "status",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <div>
                        <Select
                            disabled={record.isRejected === "1" || record.isApproved === "1"}
                            placeholder={
                                record.isRejected === "1"
                                    ? "Rejected"
                                    : record.isApproved === "1"
                                        ? "Approved"
                                        : "Select "
                            }
                            style={{
                                width: 120,
                            }}
                            onChange={(value) => setwithdrawAction(record.id, value)}
                            value={action[record.id]}
                        >
                            <Select.Option value="approve">Approved</Select.Option>
                            <Select.Option value="reject">Rejected</Select.Option>
                        </Select>
                        {action[record.id] === "reject" && (
                            <Popconfirm
                                title={
                                    <div>
                                        <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                                            Are you sure to reject this request?
                                        </p>
                                    </div>
                                }
                                // onConfirm={() => changeRequestStatus("reject", record)}
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <Button type="link">Submit</Button>
                            </Popconfirm>
                        )}
                        {action[record.id] === "approve" && (
                            <Popconfirm
                                title={
                                    <div>
                                        <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                                            Are you sure to approve this request?
                                        </p>
                                    </div>
                                }
                                // onConfirm={() => changeRequestStatus("approve", record)}
                                okText="Yes"
                                cancelText="Cancel"
                            >
                                <Button type="link" size="small">
                                    Submit
                                </Button>
                            </Popconfirm>
                        )}
                    </div>
                );
            },
        },
    ];
    const dataSource = [
        {
            key: "1",
            name: "Mike",
            age: 32,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "2",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "3",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "4",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
        {
            key: "5",
            name: "John",
            age: 42,
            address: "10 Downing Street",
            date: "15 December, 2020",
        },
    ];

    const columns = [
        // {
        //     title: "Image",
        //     dataIndex: "imageUrl",
        //     key: "imageUrl",
        //     className: "custom-header",
        //     render: (text) => {
        //         return (
        //             <>
        //                 <p className="font-medium w-[120px]">
        //                     <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
        //                 </p>
        //             </>
        //         );
        //     },
        // },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            className: "custom-header ",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: "custom-header whitespace-nowrap",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Phone no.",
            dataIndex: "mobile_number",
            key: "mobile_number",
            className: "custom-header",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            className: "custom-header",
        },
        {
            title: "Created Time",
            dataIndex: "register_date",
            key: "register_date",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs">
                            {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            className: "custom-header",
            render: (_, record) => (
                console.log("==========?>>>>>>>>>>>", record),
                <Popover
                    content={popoverContent(record.id, record.is_active)}
                    trigger="click"
                    placement="bottom"
                >
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: record.is_active == 1 ? "green" : "red",
                            backgroundColor: record.is_active == 1 ? "#e0f5f0" : "#FFE1E1",
                            borderColor: record.is_active == 1 ? "lightgreen" : "pink",
                            borderRadius: "0px",
                            cursor: "pointer",
                        }}
                    >
                        {record.is_active == 1 ? "Active" : "Inactive"}
                    </Tag>
                </Popover>
            ),
        },
    ];
    return (
        <div className="p-4">
            {/* Search Section */}
            <div className="flex justify-end mb-4">
                <Input
                    placeholder="Search user by name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "26%" }}
                />
            </div>

            {/* Card Wrapper for Table */}
            <Card
                title="Restaurant Data"
                // extra={
                //     <Button
                //         type="primary"
                //         icon={<PlusOutlined />}
                //         onClick={() => console.log("Add Order")}
                //         className="rounded"
                //     >
                //         Add Restro
                //     </Button>
                // }
                className="shadow-sm shadow-gray-300"
            >
                <Table
                    bordered={true}
                    loading={isLoading}
                    columns={columns}
                    dataSource={orderData}
                    pagination={false}
                    className="history-table animate-fade-in max-h-[500px] overflow-x-auto text-white rounded-lg"
                    size="small"
                />
            </Card>

            {/* Pagination */}
            <Pagination
                className="mt-4 text-xs w-full flex justify-end"
                total={totalPages * 10} // Assuming 10 items per page
                showTotal={(total, range) => `${range[0]}-${range[1]} of ${totalPages * 10} items`}
                onChange={handlePageChange}
                defaultPageSize={10}
                current={currentPage}
            />
        </div>
    );
};
export default AllRestroList;
